import { ApiResponse } from 'src/app/shared/model/ApiResponse';
import { PageInfo } from 'src/app/shared/model/PageInfo';
import { SharedService } from 'src/app/shared/common-services/shared.service';
import { Template, TemplatesResponse } from 'src/app/core/model';

export class TemplateAdapter {

  public static parseData(response: any, _sharedService?: SharedService): ApiResponse<TemplatesResponse> {


    if (!response || !Array.isArray(response.data)) {
      return new ApiResponse(true, 'Unable to get templates data');
    }

    if (response.data.length == 0) {
      return new ApiResponse(true, 'No templates found');
    }

    if (!response.pageInfo) {
      return new ApiResponse(true, 'Unable to get page info');
    }

    let templates: Template[] = [];

    response.data.forEach((eachTemplate: any) => {

      let template: Template = new Template();
      template.csvUrl = eachTemplate?.csvUrl;
      template._id = eachTemplate?._id;
      template.templateId = eachTemplate?.templateId;
      template.description = eachTemplate?.description;
      template.createdDate = eachTemplate && eachTemplate?.metadata?.createdDate ? this.convertDate(new Date(eachTemplate?.metadata?.createdDate)) : '';
      template.modifiedDate = eachTemplate && eachTemplate?.metadata?.modifiedDate ? this.convertDate(new Date(eachTemplate?.metadata?.modifiedDate)) : '';
      template.tenantName = eachTemplate?.tenantDetails?.[0]?.name;
      template.tenantId = eachTemplate?.tenantDetails?.[0]?._id;
      template.payloadSchema = eachTemplate?.payloadSchema;
      template.templateName = eachTemplate?.templateName;
      template.payloadType = eachTemplate?.payloadType;
      template.batchesCount = eachTemplate?.batchesCount;
      template.payloadSize = eachTemplate?.payloadSize;
      template.published = eachTemplate?.published;
      templates.push(template);
    });

    let pageInfo: PageInfo = new PageInfo();

    Object.assign(pageInfo, response.pageInfo);

    return new ApiResponse(false, '', new TemplatesResponse(templates, pageInfo));
  }

  /**
   * Converts date
   * @param date 
   * @returns  
   */
  private static convertDate(date: Date) {
    let dateStr =
      ('00' + (date.getMonth() + 1)).slice(-2) + '/' +
      ('00' + date.getDate()).slice(-2) + '/' +
      date.getFullYear() + ' ' +
      ('00' + date.getHours()).slice(-2) + ':' +
      ('00' + date.getMinutes()).slice(-2) + ':' +
      ('00' + date.getSeconds()).slice(-2);
    return dateStr;
  }
}
